import type { EdsCategoryOpenEventPayload } from '@/features/eds/components/EdsCategories/events/types/EdsCategoryOpenEventPayload';
import { EventV2 } from '@/services/EventService/abstract/EventV2';

export default class EdsCategoryOpenEvent extends EventV2<EdsCategoryOpenEventPayload> {}
